<template>
    <div class="scrolling-document p-3" v-scroll.immediate="updateScrollBounds">
        <draggable
            :key="pages.length"
            :list="pages"
            v-bind="{ghostClass: 'moving'}"
            animation="150"
            :multi-drag="true"
            selected-class="multi-drag"
            :class="{'row no-gutters': isPageOrderable}"
            :disabled="!isPageOrderable || contextMenuStatus"
        >
            <ScrollingPage
                v-for="(doc, index) in pages"
                :key="`${doc.page.pageNumber}${getPdfId(doc.id)}`"
                :class="{'col-4 col-md-3 col-xl-2 p-3': isPageOrderable}"
                :page="doc.page"
                v-bind="{clientHeight, scrollTop, focusedPage, enablePageJump}"
                v-slot="{isPageFocused, isElementFocused, pdfid}"
                @page-jump="onPageJump"
                :pdfid="getPdfId(doc.id)"
            >
                <div class="scrolling-page">
                    <slot :page="doc.page" v-bind="{index, isPageFocused, isElementFocused, pdfid}"></slot>
                </div>
            </ScrollingPage>
        </draggable>
        <div v-visible="fetchPages" class="observer"></div>
    </div>
</template>

<script>
import scroll from './directives/scroll';
import visible from './directives/visible';
import draggable from "vuedraggable";
import ScrollingPage from './ScrollingPage';

export default {
    components: {
        ScrollingPage,
        draggable
    },

    directives: {
        visible,
        scroll,
    },

    props: {
        pages: {
            required: true,
        },

        enablePageJump: {
            type: Boolean,
            default: false,
        },
        currentPage: {
            default: 1,
        },
        isParentVisible: {
            default: true,
        },
        isPageOrderable: {
            type: Boolean,
            default: false
        },
        isPreview: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            focusedPage: undefined,
            scrollTop: 0,
            clientHeight: 0,
            contextMenuStatus: false,
            undo: []
        };
    },

    computed: {
        pagesLength() {
            return this.pages.length;
        },
    },

    methods: {
        getPdfId(id) {
            if (this.pages.length) {
                return `-${id}`;
            }
            return '';
        },

        keyFunctions(e) {
            let key = e.keyCode;
            let ctrl = e.metaKey || e.ctrlKey;
            if (e.Handled) return;
            switch (key) {
                case 8:
                    if (this.isPageOrderable) {
                        let indexs = [];
                        const selected = $('.multi-drag .pdf-thumbnail').each(function () {
                            let index = $(this).data('index');
                            indexs.push(index);
                        });

                        this.$bus.$emit('pdf::pages::remove', indexs);
                        this.indexs = [];
                    }
                    break;
                case 90:
                    if (ctrl != true) return;
                    this.$bus.$emit('pdf::pages::restore', true);
                    break;
                default:
                    return;
                    break;
            }
            e.Handled = true;
        },

        fetchPages(currentPage) {
            this.$bus.$emit('pdf::pages::fetch', currentPage);
        },

        onPageJump(scrollTop) {
            this.$emit('page-jump', scrollTop);
        },

        updateScrollBounds() {
            const {scrollTop, clientHeight} = this.$el;
            this.scrollTop = scrollTop;
            this.clientHeight = clientHeight;
        },

        contextMenuclose() {
            this.contextMenuStatus = false;
        },

        contextMenuOpen() {
            this.contextMenuStatus = true;
        }
    },

    watch: {
        isParentVisible: 'updateScrollBounds',

        pagesLength(count, oldCount) {
            if (oldCount === 0) this.$bus.$emit('pdf::pages::reset');

            // Set focusedPage after new pages are mounted
            this.$nextTick(() => {
                this.focusedPage = this.currentPage;
            });
        },

        currentPage(currentPage) {
            if (currentPage > this.pages.length) {
                this.fetchPages(currentPage);
            } else {
                this.focusedPage = currentPage;
            }
        },
    },
    mounted() {
        this.$bus.$on('pdf::contextmenu::menuopen', this.contextMenuOpen);
        this.$bus.$on('pdf::contextmenu::menuclose', this.contextMenuclose);
    },
    created() {
        window.addEventListener('keydown', this.keyFunctions);
    },
    beforeDestroy() {
        this.$bus.$off('pdf::contextmenu::menuopen');
        this.$bus.$off('pdf::contextmenu::menuclose');
    },
    destroyed() {
        window.removeEventListener('keydown', this.keyFunctions);
    },
}
</script>
<style lang="scss">
.moving {
    opacity: 0 !important;

    .zoom {
        opacity: 0 !important;

        .pdf-toolbox {
            opacity: 0 !important;
        }
    }
}

.multi-drag {
    .thumbnail-container {
        background: #e6e6e6;
    }
}

.scrolling-page:not(.moving) {
    .zoom {
        &:hover {
            .pdf-toolbox {
                display: flex;
            }
        }
    }
}
</style>
